import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Config from "../../../config/config";
import { refreshAccessToken } from "../../Authorization/authSlice";


const serverPath = Config.serverPath;

// UPDATE READ MESSAGE

export const updateReadMessage = createAsyncThunk(
    "messages/read", async(id, thunkApi) => {
       console.log(id);
       const {dispatch} = thunkApi;
        const url = serverPath + "/api/messages/read/";
        const urlToFetch = `${url}/${id}`;
        const response = await fetch(urlToFetch, {
            method: 'PUT',
            headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
           
            credentials: 'include',
            mode: 'cors',
        });
        
        if (response.ok) {
            const answer = await response.json();
            console.log('Успех UPDATE READ MESSAGE:', JSON.stringify(answer));
           // console.log(answer.user);
           
            return answer;
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(updateReadMessage(id));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            } 
            
        } else {
            
    
           const answer = await response.json();
            console.log(answer.message);
    
            console.log('BAD UPDATE READ MESSAGE');
            return response.status;
           // console.log(response.status);
           // console.log(response)
        }
    
    
    }
    );

//INITIAL STATE
const initialState ={
   
   
    selectedIdMessage: null,
    selectedCategory: null,
    
};

const options = {
    name: 'messages',
    initialState: {
    selectedIdMessage: null,
    selectedCategory: 1,
    nameSelectedCategory:'Входящие сообщения',
    /*messages: [{
        id:232333,
        userId:48,
        contact:{id:47,nickName:'12323', avatarName:'12122'},
        title:'СП63.13330.2018',
        text:'Look',
        data:'24.02.24',
        mesCategory:2,
        mesHref:1,
        itemId:41,
        read:false,
    },
    {
        id:2452232,
        userId:10000,
        contact:{id:47,nickName:'12323', avatarName:'12122'},
        title:'Приветствие!',
        text:'Мы рады Вас видеть на нашем сайте!',
        data:'07.07.24',
        mesCategory:1,
        mesHref:6,
        itemId:41,
        read:true,
    },
    {
        id:2323331,
        userId:47,
        contact:{id:48,nickName:'3413123', avatarName:'121231662'},
        title:'СП63.13330.2018',
        text:'Look',
        data:'25.03.24',
        mesCategory:2,
        mesHref:1,
        itemId:41,
        read:false,
    }],*/

    //message data
    messagesUserDataInbox: [],
    messagesUserDataSend: [],
    messagesDataAdmin: [],
    messagesDataBuisness: [],
   
    //for share
    mesHref:'',


    },
reducers: {
    getInitialStateMessages: state  => 
    initialState,

    // UPDATE DATA MESSAGES

    updateMessagesDataInbox: (state, action) => {
        state.messagesUserDataInbox = action.payload;
        
    },
    updateMessagesDataSend: (state, action) => {
        state.messagesUserDataSend = action.payload;
        
    },
    updateMessagesAdmin: (state, action) => {
        state.messagesDataAdmin = action.payload;
       
    },
    updateMessagesDataBuisness: (state, action) => {
        state.messagesDataBuisness = action.payload;
        
    }, 
    selectedCategoryOfMessages: (state, action) => {
        state.selectedCategory = action.payload;
        if (action.payload === 1) {
            state.nameSelectedCategory = 'Входящие сообщения';
        }
        if (action.payload === 2) {
            state.nameSelectedCategory = 'Исходящие сообщения';
        }
        if (action.payload === 3) {
            state.nameSelectedCategory = 'WSCproject сообщения';
        }
        if (action.payload === 4) {
            state.nameSelectedCategory = 'Деловые сообщения';
        }

    },
    selectIdOfMessage: (state, action) => {
       // console.log(action.payload);
        state.selectedIdMessage = action.payload;
    },
    clearIdMessage: (state, action) => {
        state.selectedIdMessage = null;
    },
    sortedDataMessages: (state, action) => {

        const data = action.payload.data;
        const userId =action.payload.userId;
        console.log('1.1.1 START SORT MESSAGE DATA');

        let messagesUserDataInbox = [];
        let messagesUserDataSend = [];
        let messagesDataAdmin = [];
        let messagesDataBuisness = [];
    
            //TO INBOX
        for (let i=0; i < data.length ; i++) {
            console.log('1.1.1.1 START 1');
            let  dataUserId = data[i].user.id;
          
            if (((userId === dataUserId) && (data[i].mesCategory === 2))||((userId === dataUserId) && (data[i].mesCategory === 1))) {
                console.log('1.1.1.1 START 1');
                //console.log(data[i].userId);
                //console.log(data[i].mesCategory);
               // console.log(data[i]);
                //console.log(data.length);
                messagesUserDataSend.push(data[i]);
                
            //TO SEND
            } 
            if ((userId !== dataUserId) && (data[i].mesCategory === 2)) {
                console.log('1.1.1.2 START 2');
                messagesUserDataInbox.push(data[i]);
            //TO ADMIN
        } 
        
            if (((userId !== dataUserId) && (data[i].mesCategory === 1))||((userId === dataUserId) && (data[i].mesCategory === 1))) {
            console.log('1.1.1.3 START 3');
                messagesDataAdmin.push(data[i]);
            }
            //TO BUISNESS
            
            if ((userId !== dataUserId) && (data[i].mesCategory === 3)) {
                console.log('1.1.1.1 START 4');
                messagesDataBuisness.push(data[i]);
            }
                
        }
        state.messagesUserDataInbox = messagesUserDataInbox;
        state.messagesUserDataSend = messagesUserDataSend;
        state.messagesDataAdmin = messagesDataAdmin;
        state.messagesDataBuisness = messagesDataBuisness;

    
     },
     deleteMessageReducer: (state, action) => {


      console.log('Start sorted messages after delete message');

      
        if (state.selectedCategory === 1) {
          
            const index = state.messagesUserDataInbox.findIndex(item => 
                item.id === action.payload);
            console.log(index);
            state.messagesUserDataInbox.splice(index,1);
        }
        if (state.selectedCategory === 2) {
           
            const index = state.messagesUserDataSend.findIndex(item => 
                item.id === action.payload);
            console.log(index);
            state.messagesUserDataSend.splice(index,1);
        }
        if (state.selectedCategory === 3) {
           
            const index = state.messagesDataAdmin.findIndex(item => 
                item.id === action.payload);
            console.log(index);
            state.messagesDataAdmin.splice(index,1);
        }
      
  





        console.log(action.payload);
                
     },
     addMessageReducer: (state, action) => {


        console.log('Start add message after send message');

        const res = action.payload[0];
       /* const newMessage =  {
            id: res.id,
            userId:res.user_id,
            contact:{id:res.contact_id, nickName:res.user_nickname, avatarName:res.user_image_name},
            title:res.title,
            text:res.text,
            data:res.data,
            mesCategory:res.mes_category,
            mesHref:res.mes_href,
            itemId:res.item_id,
            read:res.read, 
        };
        */
        state.messagesUserDataSend.push(res);

  
  
  
  
  
          console.log(action.payload);
          //console.log(newMessage);        
       },
       //FOR SHARE
       mesHrefSetForShare: (state, action) => {
        state.mesHref = action.payload;
       }
    },
extraReducers: (builder) => {
        builder
        //READ MESSAGE
        .addCase(updateReadMessage.pending, (state) => {
            state.isFetching = true;
            state.error = false;
            state.userMessage = 'Загрузка...';
        })
        .addCase(updateReadMessage.fulfilled, (state, action) => {
            console.log(action.payload);
           
            if (action.payload) {
                       // let data;
            if (state.selectedCategory === 1) {
                //data = state.messagesUserDataInbox;
                const index = state.messagesUserDataInbox.findIndex(item => 
                    item.id === action.payload[0].id);
                //console.log(index);
                state.messagesUserDataInbox[index].read = true;
            }
            if (state.selectedCategory === 3) {
               // data = state.messagesDataAdmin;
                const index = state.messagesDataAdmin.findIndex(item => 
                    item.id === action.payload[0].id);
                //console.log(index);
                state.messagesDataAdmin[index].read = true;
            }
        }
            //DONT UNDERST WHY  state.messagesUserDataInbox DONT WORK IF DATA SET!!!!!!
           // console.log(state.selectedCategory);
           // console.log(state);
           // console.log(state.messagesUserDataInbox);
            //console.log(data);
            //console.log(data[0]);
/*
            const index = state.data.findIndex(item => 
                item.id === action.payload[0].id);
            console.log(index);
            state.data[index].read = true;
            */
        })
        .addCase(updateReadMessage.rejected, (state,action) => {
            state.isFetching = false;
            state.error = action.payload;
            state.errorMessage = 'Сервер временно недоступен';
            state.userMessage ='';
            console.log('bad update read MESSAGE');
        })

    }

};

export const  messagesSlice = createSlice(options);
export const {updateMessagesDataInbox, updateMessagesDataSend, updateMessagesAdmin, 
    updateMessagesDataBuisness, selectedCategoryOfMessages, selectIdOfMessage, clearIdMessage, 
    sortedDataMessages, getInitialStateMessages, deleteMessageReducer,
    mesHrefSetForShare, addMessageReducer} = messagesSlice.actions;
export default messagesSlice.reducer;


